import { ReactNode, createContext, useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

export type AdminLayout = "desktop" | "phone";

// The design system turns table rows into cards below 640px wide (its `sm`
// breakpoint); every kit component switches to its phone layout there (PHONE-R1).
const phoneLayoutQuery = "(max-width: 639.98px)";

const AdminLayoutContext = createContext<AdminLayout | undefined>(undefined);

interface AdminLayoutProviderProps {
  layout: AdminLayout;
  children: ReactNode;
}

// Fixes the layout for everything inside it, whatever the window's width: the
// gallery's phone frames and the tests use it.
export const AdminLayoutProvider = ({ layout, children }: AdminLayoutProviderProps) => (
  <AdminLayoutContext.Provider value={layout}>{children}</AdminLayoutContext.Provider>
);

// The layout a kit component draws: the one a provider fixes, otherwise the one the
// window's width calls for.
export const useIsPhoneLayout = (): boolean => {
  const fixedLayout = useContext(AdminLayoutContext);
  const isNarrowWindow = useMediaQuery(phoneLayoutQuery, { noSsr: true });

  if (fixedLayout) return fixedLayout === "phone";

  return isNarrowWindow;
};
